import { render, staticRenderFns } from "./AssetPropertiesUpsertComponent.vue?vue&type=template&id=12200e7c&scoped=true&"
import script from "./AssetPropertiesUpsertComponent.vue?vue&type=script&lang=ts&"
export * from "./AssetPropertiesUpsertComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AssetPropertiesUpsertComponent.vue?vue&type=style&index=0&id=12200e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12200e7c",
  null
  
)

export default component.exports